// extracted by mini-css-extract-plugin
module.exports = {"button":"button__2xxCY","accept":"accept__3o6NM","decline":"decline__3Ch_e"};